export default __webpack_public_path__ + "static/media/37-membrane.8eeea61e.png";